import api from 'utils/api';

export const endpoints = {
  request: () => `/commons/accounts/phone-number/`,
  resend: () => `/commons/accounts/phone-number/resend/`,
  confirm: () => `/commons/accounts/phone-number/confirm/`,
};

export function requestPhoneNumberChange({ phoneNumber }) {
  return api({
    method: 'post',
    url: endpoints.request(),
    data: { phoneNumber },
  });
}

export function resendPhoneNumberCode() {
  return api({
    method: 'post',
    url: endpoints.resend(),
  });
}

export function confirmPhoneNumberChange({ code }) {
  return api({
    method: 'post',
    url: endpoints.confirm(),
    data: { code },
  });
}
